import { PurchaseDocument } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  getPurchaseDocumentBuyer,
  getTransformedDate,
  getFormatedPrice,
  getProjectUnit,
} from '../helpers'
import {
  CustomHeaderText,
  CustomTitle,
  FormLabels,
} from 'src/components'
import { getProjectKindLabel } from '../helpers/validate-documents.helpers'

const documentListColumns: ColumnsType<PurchaseDocument> = [
  /* Purchase Documents Data */

  {
    title: () => <CustomHeaderText text='Withdrawals.CreatedDate' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, document) => <CustomTitle label={getTransformedDate(document.created)} />
  },
  {
    title: () => <CustomHeaderText text='admin.Brokerage.ProjectName' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => a.project_name.length - b.project_name.length,
    render: (_, document) => <CustomTitle label={document.project_name} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Document.ProjectKind' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => a.project_kind.length - b.project_kind.length,
    render: (_, document) => <CustomTitle label={getProjectKindLabel(document.project_kind)} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Document.Registry' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => a.registry.length - b.registry.length,
    render: (_, document) => <CustomTitle label={document.registry} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Document.Buyer' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => {
      return getPurchaseDocumentBuyer(a).length - getPurchaseDocumentBuyer(b).length
    },
    render: (_, document) => <CustomTitle label={getPurchaseDocumentBuyer(document)} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Amount' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => a.amount - b.amount,
    render: (_, document) => {
      return <CustomTitle label={`${document.amount} ${getProjectUnit(document.project_kind)}`} type={null} />
    }
  },
  {
    title: () => <CustomHeaderText text='Projects.Price' />,
    responsive: ['sm'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => a.total - b.total,
    render: (_, document) => {
      const label = `${getFormatedPrice(document.total, document.currency)} - ${document.currency}`
      return <CustomTitle label={label} type={null} />
    }
  },


  /* Mobile View */
  {
    title: () => <CustomHeaderText text='Document.Purchase' isCentered />,
    responsive: ['xs'],
    sorter: (a: PurchaseDocument, b: PurchaseDocument) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, document) => {
      const buyer = getPurchaseDocumentBuyer(document)
      const price = getFormatedPrice(document.total, document.currency)
      const amount = `${document.amount} ${getProjectUnit(document.project_kind)}`
      const subtitle = `${buyer}: ${price} - ${amount}`
      return <FormLabels
        title={document.project_name}
        subtitle={getTransformedDate(document.created)}
        thirdLabel={subtitle}
      />
    }
  },
]

export default documentListColumns
